// module
import { terminateConnection } from './ws'
import { IS_IOS } from '$func/environmentInfo'
import { dispatchSetIsMultiTab } from '$comp/main/root.action'
import { dateWithOffset } from '$setup/time-offset'

if (!IS_IOS) {
  let isMaster = true

  const onLocalStorageEvent = e => {
    if (!isMaster) return

    if (e.key === 'openWeblite') {
      isMaster = false
      terminateConnection()
      dispatchSetIsMultiTab(true)
    }
  }

  window.addEventListener('storage', onLocalStorageEvent)

  localStorage.openWeblite = dateWithOffset()
}
